<script>
import Vue from 'vue';

export default {
  name: 'HasChangesDetection',
  data () {
    return {
      originalData: {}
    };
  },
  mounted () {
    if (typeof this.isEdit !== 'undefined' && !this.isEdit) {
      this.originalData = JSON.stringify(this.data);
    } else {
      this.$watch('allDataLoaded', (newValue, oldValue) => {
        if (newValue && !oldValue) {
          Vue.nextTick(() => {
            let currentState = JSON.parse(JSON.stringify(this.data));

            if (typeof currentState.pax_number !== 'undefined') {
              delete currentState.pax_number
            }

            if (typeof currentState.tbc_count !== 'undefined') {
              delete currentState.tbc_count
            }

            this.originalData = JSON.stringify(currentState);
          }, 250);
        }
      });
    }
  },
  methods: {
    updateOriginalData () {
      let currentState = JSON.parse(JSON.stringify(this.data));

      if (typeof currentState.pax_number !== 'undefined') {
        delete currentState.pax_number;
      }

      if (typeof currentState.tbc_count !== 'undefined') {
        delete currentState.tbc_count;
      }

      this.originalData = JSON.stringify(currentState);
    },
    checkForChanges (successCallback) {
      let currentState = JSON.parse(JSON.stringify(this.data));

      if (typeof currentState.pax_number !== 'undefined') {
        delete currentState.pax_number;
      }

      if (typeof currentState.tbc_count !== 'undefined') {
        delete currentState.tbc_count;
      }

      if (JSON.stringify(currentState) === this.originalData) {
        successCallback();
        return;
      }

      Vue.swal({
        title: 'You have unsaved changes',
        html: 'Do you want to continue - you will lose all changes.',
        icon: 'question',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          successCallback();
        }
      }).catch((errors) => {
        console.log(errors);
      });
    }
  }
}
</script>
